var _defs, _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSam(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: none;\n      }\n    "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    y: 0,
    width: 30,
    height: 30
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.2,29c-.7,0-1.5-.4-2-.9-3.5-2.8-1.9-9.8-3.1-13.8s-2.8-2.7-3.5-4.4-.6-2-.4-2.8,1-1.3,1.1-1.7c.1-.9-.5-1.2.1-2s1.4-1.5,2.2-1.4c2.5.2,3.9,1,5.9,2.5s2,2.5,4.2,3.3,3,.5,2.7,1.8-.7,1.3-.9,1.9c-.3,1-.3,2.4-.9,3.1s-.9.8-1.3,1.2c-1.7,1.7-2.4,4.4-4.3,6.2s-1.2.8-1.4,1.3,0,1,0,1.5,0,1.8.1,2.5.9,1.1,1.4,1.6Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSam);
export default __webpack_public_path__ + "static/media/SAM.d02ac3e3ce3c3724e30f8abb3a0dcca7.svg";
export { ForwardRef as ReactComponent };